function hslToRgb(h, s, l) {
	let r, g, b;

	if (s === 0) {
		r = g = b = l; // achromatic
	} else {
		let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
		let p = 2 * l - q;
		r = hue2rgb(p, q, h + 1 / 3);
		g = hue2rgb(p, q, h);
		b = hue2rgb(p, q, h - 1 / 3);
	}
	return [Math.floor(r * 255), Math.floor(g * 255), Math.floor(b * 255)];
}
function hue2rgb(p, q, t) {
	if (t < 0) t += 1;
	if (t > 1) t -= 1;
	if (t < 1 / 6) return p + (q - p) * 6 * t;
	if (t < 1 / 2) return q;
	if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	return p;
}

export function freshnessToColorHsl(hours) {
	const maxHours = 24;
	let ratio = hours / maxHours;
	if (ratio > 1) {
		ratio = 1;
	}
	ratio = 1 - ratio;
	const hue = (ratio * 1.2) / 3.6;
	const rgb = hslToRgb(hue, 1, 0.5);
	return 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
}
